const es = {
  'Language Key': 'es',
  'cui-org-info': 'Datos de la organización',
  'cui-sign-on-info': 'Firmar en información',
  'cui-user-info': 'Información de usuario',
  'cui-preferences': 'preferencias',
  'cui-review': 'revisión',
  'cui-org': 'Organización',
  'cui-company-division': 'Division de la empresa',
  'cui-org-address': 'organización Dirección',
  'cui-user-address': 'Dirección de usuario',
  'cui-country': 'País',
  'cui-city': 'Ciudad',
  'cui-state': 'Provincia del estado',
  'cui-postal': 'código postal',
  'cui-user-id': 'Identidad de usuario',
  'cui-password': 'Contraseña',
  'cui-password-re': 'Escriba la contraseña otra vez',
  'cui-challenge-question': 'Pregunta desafiante',
  'cui-challenge-answer': 'desafío respuesta',
  'cui-favorite-pet-q': '¿Cuál es el nombre de su mascota favorita?',
  'cui-mother-q': '¿Cuál es el apellido de soltera de tu madre?',
  'cui-best-friend-q': '¿Quién es tu mejor amigo?',
  'cui-first-name': 'Nombre de pila',
  'cui-last-name': 'Apellido',
  'cui-email': 'Email',
  'cui-email-re': 'Volver a introducir correo electrónico',
  'cui-telephone': 'Número de teléfono',
  'cui-timezone': 'Zona horaria',
  'cui-submit': 'ENVIAR',
  'cui-next': 'PRÓXIMO PASO',
  'cui-previous': 'ANTERIOR',
  'cui-create-security-admin-account': 'Crea tu cuenta de administrador de seguridad',
  'cui-skip-for-now': 'Omitir por ahora',
  'icon-library': 'Biblioteca icono',
  'cui-new-TLO': 'Nueva organización de primer nivel',
  'cui-new-TLO-description': 'Seleccione este método si desea unirse a la Bolsa de Covisint como una nueva organización de Covisint',
  'cui-new-division': 'nueva División',
  'cui-new-division-description-start': 'Seleccione este método si desea convertirse en el',
  'cui-new-division-description-end': 'de una nueva división dentro de una organización de Covisint existente.',
  'cui-security-administrator': 'Administrador de seguridad',
  'cui-new-user': 'Nuevo usuario',
  'cui-new-user-description': 'Seleccione este método si usted es un empleado de una empresa existente Covisint miembro el acceso a la búsqueda de una aplicación a su organización suscriba o si no está seguro de si se ha registrado en su organización.',
  'cui-sign-up': 'Regístrate',
  'cui-address': 'Dirección',
  'cui-organization-name': 'Division de la empresa',
  'cui-supplier-code': 'Código de proveedor',
  'cui-address-1': 'Dirección 1',
  'cui-address-2': 'Dirección 2',
  'cui-user-information': 'informacion del usuario',
  'cui-organization-information': 'Información de la organización',
  'cui-sign-in-information': 'Iniciar sesión Información',
  'cui-package-selection': 'Selección de paquetes',
  'cui-welcome-popover': 'Las responsabilidades del administrador de seguridad se explicarán en detalle después de seleccionar un método de registro. Sin embargo, puede optar por cancelar su registro con el fin de permitir que un miembro diferente de su Organiziation para registrarse como el administrador de seguridad.',
  'create-account': 'Crea tu cuenta',
  'cui-agree-covisint': 'Estoy de acuerdo con la Covisint',
  'terms-of-service': 'Términos de servicio',
  'cui-and': 'y',
  'privacy-policy': 'Política de privacidad',
  'cui-tos-agree': 'Debe aceptar las condiciones de servicio para continuar.',
  'cui-user-profile': 'Perfil del usuario',
  'cui-my-profile': 'Mi perfil',
  'cui-login': 'Iniciar sesión',
  'cui-supplier-content': 'Actualizar esta vez los documentos de diseño vienen en. Esta se encuentra en la traducción de Google doc. Lorem Ipsum. Otras cosas. código del proveedor de información importante. Me gustan las tortugas.',
  'cui-all-organizations': 'Todas las Organizaciones:',
  'cui-application-select-info': 'Siempre se puede hacer sus selecciones después de iniciar sesión por primera vez.',
  'cui-all-applications': 'Todas las aplicaciones',
  'cui-page-not-found': 'Página no encontrada',
  'cui-page-not-found-content': 'La página que está buscando pudo haber sido eliminado o nunca han existido.',
  'cui-home': 'CASA',
  'cui-access-denied': 'Acceso denegado',
  'cui-access-denied-content': 'No está autorizado para ver esta página.',
  'cui-registration-status': 'estado de registro',
  'cui-pending-status': 'Estatus pendiente',
  'cui-pending-status-content': 'Su estado de registro aún está pendiente. Usted recibirá un correo electrónico con más detalles en breve.',
  'cui-thank-you': 'Gracias',
  'cui-request-submitted': 'solicitud enviada',
  'cui-success': 'Éxito',
  'cui-success-content': 'Su registro de Covisint ha sido enviado correctamente. Usted recibirá un correo electrónico con más detalles en breve.',
  'cui-check-your': 'Revisar su',
  'cui-registration-status-lower': 'estado de registro',
  'cui-application-selection': 'Selección de aplicación',
  'cui-applications': 'aplicaciones',
  'cui-profile-settings': 'Configuración de perfil',
  'cui-name': 'Nombre',
  'cui-update': 'Actualizar',
  'cui-updated': 'Actualizado',
  'cui-error-try-again': '¡Error! ¿Inténtalo de nuevo?',
  'cui-back': 'Espalda',
  'cui-selections': 'Trozos escogidos',
  'cui-add-org': 'Añadir Organización',
  'cui-remove-org': 'Retire Organización',
  'cui-select-org': 'Seleccionar Organización',
  'cui-more-information': 'Más información',
  'cui-inv-user-popover-info': 'Por razones de seguridad, usted debe registrarse con la dirección de correo de su invitación fue enviada. Esto puede ser editado dentro de la configuración del usuario cuando el registro se ha completado.',
  'cui-org-profile': 'Perfil de la organización',
  'cui-info': 'información',
  'cui-admins': 'Administradores',
  'lowercase-not-allowed': 'no tiene ningún letras minúsculas',
  'uppercase-not-allowed': 'no tiene ningún letras mayúsculas',
  'numbers-not-allowed': 'sin tener números',
  'special-not-allowed': 'no tiene ningún símbolos especiales (por ejemplo:! * +)',
  'chars-not-allowed': 'no contener ninguno de los siguientes caracteres: {{disallowedChars}}',
  'words-not-allowed': 'no contiene ninguna de las siguientes palabras: {{disallowedWords}}',
  'password-length': 'tener entre {{min}}-{{max}} caracteres',
  'password-rules': 'tener {{requiredNumberOfCharClasses}} de lo siguiente:',
  'password-lowercase': 'al menos 1 letra minúscula',
  'password-uppercase': 'al menos 1 mayúscula',
  'password-number': 'número al menos 1',
  'password-special': 'al menos 1 símbolo especial (por ejemplo:! * +)',
  'passwords-must': 'Las contraseñas deben:',
  'welcome-title': 'Inscribirse en una de las siguientes',
  'cui-application-name': 'Nombre de la aplicación',
  'cui-application-tos': 'Review Términos y Condiciones',
  'cui-application-tos-agreement': 'Términos y condiciones Acuerdo',
  'cui-package-tos': 'No ha aceptado las condiciones de los paquetes seleccionados.',
  'cui-view-tos': 'Ver Términos y Condiciones',
  'password-mismatch': 'Las contraseñas deben coincidir',
  'cui-back-to-review': 'Volver a la opinión',
  'email-mismatch': 'Los correos electrónicos deben coincidir',
  'no-applications-selected': 'No es necesario que todas las aplicaciones seleccionadas. Haga clic aquí para volver a la selección de la aplicación.',
  'cui-all-fields-required': 'Todos los campos son obligatorios',
  'cui-complete-registration': 'Complete su registro a continuación con',
  'cui-registered': 'Registrado',
  'cui-open': 'Abierto',
  'cui-close': 'Cerca',
  'cui-street-address': 'Dirección',
  'cui-zip': 'Cremallera',
  'cui-language': 'Idioma',
  'cui-phone-main': 'Principal',
  'cui-phone-office': 'Oficina',
  'cui-phone-fax': 'Teléfono / Fax',
  'cui-phone-mobile': 'Móvil',
  'cui-save': 'Salvar',
  'cui-cancel': 'Cancelar',
  'cui-edit': 'Editar',
  'cui-phone': 'Teléfono',
  'search-by-app-name': 'Búsqueda por nombre de la aplicación',
  'new-request': 'Nueva solicitud',
  'select-applications': 'Seleccione Aplicaciones',
  'browse-applications': 'Consultar Aplicaciones',
  'go': 'Ir',
  'filter-list': 'Lista de filtros',
  'filter': 'Filtrar',
  'owning-org': 'Ser propietario de Org',
  'my-applications': 'mis aplicaciónes',
  'app-summary': 'Resumen de aplicaciones',
  'granted': 'Concedido',
  'bundled-applications': 'aplicaciones incluidas',
  'application-details': 'Detalles de la aplicación',
  'my-claims': 'Mis Reclamaciones',
  'related-applications': 'Aplicaciones relacionadas',
  'review-request': 'Solicitud de revisión',
  'back-to-search': 'Volver a Búsqueda',
  'requested-items': 'Los productos solicitados',
  'request-reason': 'solicitud Razón',
  'reason-im-requesting': 'Razón por la que estoy solicitando',
  'you-must-enter-a-reason': 'Debe introducir un motivo para solicitar esta aplicación',
  'cui-org-no-applications': 'Parece que su organización no tiene ninguna aplicación. Siempre puede intentar de nuevo después de iniciar la sesión.',
  'cui-filter-org-name': 'Filtrar por nombre de la organización',
  'cui-address-example': 'Edificio de apartamentos. (Opcional)',
  'cui-filter-app-name': 'Filtrar por nombre de la aplicación',
  'cui-search-user-name': 'Buscar usuarios por nombre',
  'page': 'Página',
  'cui-num-results-page': 'resultados por página',
  'submit-request': 'Enviar peticion',
  'categories': 'categorías',
  'cui-answer': 'Responder',
  'cui-enter-password': 'Introducir la contraseña',
  'cui-enter-new-password': 'Introduzca nueva contraseña',
  'cui-re-enter-new-password': 're-ingrese nueva contraseña',
  'granted-to-my-org': 'Concedida a mi organización',
  'collected-items-for-request': 'Los productos recogidos para Solicitud',
  'cui-invalid-password': 'Contraseña invalida. Inténtalo de nuevo.',
  'cui-faq': 'Preguntas más frecuentes',
  'cui-frequently-asked-questions': 'Preguntas frecuentes',
  'cui-admin-tools': 'Herramientas de administración',
  'cui-this-field-is-required': 'Este campo es requerido.',
  'cui-this-field-needs-to-be-longer': 'Este campo tiene que ser más largo.',
  'cui-you-need-to-agree-to-toc': 'Es necesario llegar a un acuerdo con los Términos de Servicio antes de continuar.',
  'cui-this-is-not-valid-email': 'Esto no es un email válido.',
  'cui-my-app-requests': 'Mis solicitudes de aplicación',
  'cui-no-claims': 'No tiene reclamaciones por esta aplicación.',
  'cui-no-details': 'No hay datos disponibles.',
  'request': 'Solicitud',
  'all': 'Todas',
  'no-selected-apps': 'No ha seleccionado ninguna aplicación.',
  'basic-info': 'Información básica',
  'cui-error-username-exists': 'ID de usuario ya existe! Por favor elije otro.',
  'password-reset': 'Restablecimiento de contraseña',
  'current-password': 'contraseña actual',
  'timezone-and-language': 'Zona horaria y Lenguaje',
  'challenge-questions': 'Preguntas del desafío',
  'security-question-repeated': 'Esta respuesta ya ha sido utilizada.',
  'cui-by-date-added': 'Fecha Agregada',
  'cui-alphabetically': 'Alfabético',
  'active': 'Activo',
  'pending': 'Pendiente',
  'suspended': 'Suspendido',
  'title': 'Título',
  'id': 'CARNÉ DE IDENTIDAD',
  'url': 'url',
  'privacy-terms': 'Términos y privacidad',
  'help': 'Ayuda',
  'cui-learn-more-start': 'Aprende más',
  'cui-learn-more-end': 'acerca de por qué solicitamos esta información',
  'cui-org-hierarchy': 'organización Jerarquía',
  'directory': 'Directorio',
  'userID': 'Identidad de usuario',
  'status': 'Estado',
  'locked': 'bloqueado',
  'rejected': 'Rechazado',
  'removed': 'Remoto',
  'sort': 'Ordenar',
  'refine': 'Refinar',
  'or': 'O',
  'organizations': 'organizaciones',
  'roles': 'Roles',
  'organization-applications': 'Aplicaciones organización',
  'unactivated': 'desactivado',
  'log-out': 'Cerrar sesión',
  'welcome': 'Bienvenido',
  'privacy': 'Intimidad',
  'terms': 'Condiciones',
  'user': 'Usuario',
  'top-level-orgs': 'Top organizaciones de nivel',
  'invite-user': 'invitar usuario',
  'invite-division': 'invitar División',
  'username': 'Nombre de usuario',
  'move': 'movimiento',
  'no-bundled-or-related': 'No incluido o aplicaciones relacionadas.',
  'cui-continue': 'Continuar',
  'cui-no-org-divisions': 'No hay divisiones organización',
  'inactive': 'Inactivo',
  'deny': 'Negar',
  'approve': 'Aprobar',
  'pending-request': 'Solicitud pendiente',
  'review-approvals': 'Las aprobaciones de revisión',
  'cui-package-no-claims': 'Este paquete contiene ninguna demanda',
  'claims': 'Reclamaciones',
  'package-name': 'Nombre del paquete',
  'submit-approvals': 'presentar aprobaciones',
  'view-details': 'Ver detalles',
  'request-date': 'Fecha de solicitud',
  'registration-decision': 'Decisión de registro',
  'requested': 'Pedido',
  'getting-user-info': 'Conseguir la información de usuario ...',
  'approvals-submitted': 'las autorizaciones presentadas',
  'rejection-submitted': 'rechazo Enviado',
  'approval-summary': 'Resumen de aprobación',
  'approved-items': 'Los productos aprobados',
  'rejected-items': 'Los productos rechazados',
  'registration-request-approved': 'solicitud de registro aprobado',
  'registration-request-rejected': 'solicitud de registro rechazado',
  'no-items-rejected': 'No hay elementos rechazados',
  'no-items-approved': 'No hay artículos aprobados',
  'registration-request': 'Solicitud de Registro',
  'custom-api-loading': 'La inicialización de la aplicación ...',
  'new-grant': 'Aplicación subvención',
  'search-by-package-name': 'Búsqueda por nombre del paquete',
  'search': 'Buscar',
  'administartor-?': '¿Administrador?',
  'submit-grant-update': 'Enviar actualización subvención',
  'review-user-pending-approval': 'Pendiente de aprobación Opinión de usuarios',
  'view-request-for': 'Ver Solicitud de',
  'job-title': 'Título profesional',
  'query': 'Consulta',
  'suspend-app': 'suspender la aplicación',
  'new-grants': 'nuevas subvenciones',
  'update-grant-settings': 'Configuración de la actualización Grant',
  'assign-new-grant-to': 'Asignar nueva concesión a',
  'division': 'División',
  'redirecting-to-sso': 'Solicitar sus credenciales',
  'included-applications': 'Aplicaciones incluidas',
  'selected-sub-packages': 'Seleccionados Sub-Paquetes',
  'specify-password': 'especificar la contraseña',
  'suspend': 'Suspender',
  'reset-password': 'Restablecer la contraseña',
  'confirm-password-reset': '¿Está seguro de que desea restablecer la contraseña de este usuario?',
  'yes': 'Sí',
  'within': 'dentro',
  'search-within': 'Buscar dentro',
  'in-your-org': 'en su org',
  'people': 'Gente',
  'revoke-package': 'revocar paquete',
  'cui-by-username': 'Nombre de usuario',
  'cui-by-status': 'Estado',
  'cool-got-it': 'Fresco, lo consiguió',
  'organization-directory': 'Directorio de la organización',
  'org-nav-invite-links': 'Organización de navegación y enlaces Invitación',
  'org-dir-filters': 'Organización Directorio Filtros',
  'org-dir-list': 'Lista Directorio de organización',
  'apps': 'aplicaciones',
  'apps-upper': 'APPS',
  'history-upper': 'HISTORIA',
  'profile-upper': 'PERFIL',
  'roles-upper': 'FUNCIONES',
  'your-app-request-in-review': 'Su petición de solicitud se ha presentado',
  'error-generic': 'Hubo un error al cargar los datos en esta página. Inténtalo de nuevo.',
  'cui-application-administrator': 'no tiene actualmente el papel de administrador de la aplicación, que debe ser asignado para que un usuario puede conceder derechos de administración para una aplicación determinada. Esta es una configuración de tiempo.',
  'cui-assign-confirm': '¿Le gustaría asignar este papel ahora?',
  'cui-suspend-warning': 'no será capaz de acceder a esta aplicación',
  'cui-suspend-confirm': '¿Seguro desea suspender ahora?',
  'cui-notify-user': 'notificar al usuario',
  'cui-users': 'usuarios',
  'cui-no': 'No',
  'cui-remove': 'Remoto',
  'cui-org-abbrev': 'org',
  'cui-userProfile-user-error': 'Hubo un error al recuperar los datos del usuario. Inténtalo de nuevo.',
  'cui-userProfile-security-error': 'Hubo un error al recuperar datos de pregunta de seguridad. Inténtalo de nuevo.',
  'cui-userProfile-password-error': 'Hubo un error al recuperar los datos de la directiva de contraseñas. Inténtalo de nuevo.',
  'cui-suspend-success': 'Esta aplicación está ahora suspendido del usuario seleccionado',
  'cui-unlock': 'desbloquear',
  'cui-unlock-password-confirm': '¿Seguro que le gustaría para desbloquear la contraseña de este usuario?',
  'cui-error-unlocking-password': 'Ha habido un error desbloquear la contraseña de este usuario.',
  'cui-error-person-request': 'No se puede recuperar datos de la solicitud de registro para este usuario.',
  'cui-error-email-exists': 'dirección de correo electrónico ya ha sido tomada',
  'cui-password-history-rule': 'no coincide con ninguna de sus {{}} numberOfPasswords contraseñas anteriores',
  'cui-password-policy': 'Política de contraseñas',
  'cui-security-admin': 'Los administradores de seguridad',
  'cui-button-loading-text': 'Cargando...',
  'cui-username-taken': 'Nombre de usuario se toma',
  'cui-no-applications': 'Actualmente no tiene aplicaciones',
  'cui-mask-answers': 'Ocultar las respuestas de seguridad / Desenmascarar',
  'cui-pwd-reset-success': 'Password Reset éxito!',
  'cui-last-login': 'Último acceso',
  'cui-need-different-app': '¿Necesita una aplicación diferente',
  'cui-go-back-to': 'Volver a',
  'cui-tos-applications': 'Por favor, acepta Términos y Condiciones para las aplicaciones seleccionadas',
  'cui-selected-apps': 'Las aplicaciones seleccionadas',
  'cui-authentication-policy': 'política de Autenticación',
  'cui-selected': 'Seleccionado',
  'cui-tac': 'Términos y Condiciones',
  'cui-accept': 'Aceptar',
  'cui-tac-agree': 'Debe aceptar los términos y condiciones para continuar.',
  'cui-printer-friendly-tac': 'Términos y condiciones para impresora',
  'cui-my-history': 'Mi historia',
  'cui-status-history': 'Mi historial de estado',
  'cui-app-history': 'Historial de la solicitud',
  'cui-password-change-log': 'registro de cambio de contraseña',
  'cui-date': 'Fecha',
  'cui-event-type': 'Tipo de evento',
  'cui-action-by': 'Acción realizada por',
  'cui-notes': 'notas',
  'cui-try-again': 'Inténtalo de nuevo.',
  'cui-password-change-log-error': 'Hubo un registro de cambios de contraseña error al recuperar.',
  'cui-userstatus-history-error': 'Hubo un historial de estado del usuario error al recuperar.',
  'cui-claims-error': 'Hubo un error al recuperar las reivindicaciones.',
  'cui-org-app-suspend-success': 'Esta aplicación está suspendida de las organizaciones seleccionadas, todos los usuarios y todas las organizaciones sub.',
  'cui-org-app-suspend-msg1': 'Esta acción suspender la acción de todos los usuarios y las organizaciones sub incluso cuando está en uso activo.',
  'cui-org-app-suspend-msg2': '¿Seguro que desea suspender',
  'cui-from': 'de',
  'cui-application-granted-history': 'Aplicación Historia de Grant',
  'cui-application-requested-history': 'Solicitud Solicitud Historia',
  'approved': 'Aprobado',
  'decision': 'Decisión',
  'evaluator': 'evaluador',
  'action': 'Acción',
  'cui-invalid-invitation': 'Invitación se utiliza ya sea o no válida',
  'cui-by-request-date': 'Fecha de solicitud',
  'cui-by-decision-date': 'Fecha de decisión',
  'cui-no-orgs-for-name': 'No se han encontrado para el nombre especificado organizaciones. Por favor, intente con un nombre diferente.',
  'requests': 'Peticiones',
  'no-pending-apps': 'No tiene solicitudes pendientes de aplicación.',
  'description': 'Descripción',
  'launch': 'Lanzamiento',
  'manage-applications': 'Administrar aplicaciones',
  'request-type': 'tipo de solicitud',
  'phase': 'Fase',
  'date-submitted': 'Fecha Enviado',
  'cui-pending-requests-error': 'Hubo un error en la recuperación / actualización de solicitudes.',
  'no-requests-by-name': 'No se han encontrado para el nombre especificado peticiones. Por favor, intente con un nombre diferente.',
  'cannot-change-password': 'No se puede cambiar la contraseña ahora',
  'select-claims': 'Seleccione Reclamaciones',
  'grant-reason': 'Razón subvención',
  'grants-assigned': 'Nuevas subvenciones Asignado',
  'suspend-error': 'Hubo un error en la suspensión de las solicitudes.',
  'unsuspend-error': 'Se produjo un error en las solicitudes Reactivar.',
  'approval': 'Aprobación',
  'administrator': 'Administrador',
  'submitted': 'Presentada',
  'no-bundled': 'Todavía no hay aplicaciones empaquetadas',
  'disallowed-password-rule': 'No puede contener una palabra en la lista de palabras anulado',
  'request-approve-or-rejected': 'Esta solicitud es aprobada, ya sea / Rechazado',
  'application': 'Solicitud',
  'show-all': 'Mostrar todo',
  'cui-subject': 'Tema',
  'cui-es': '(ES)',
  'cui-invite-user': 'Invitar a un usuario dentro de',
  'cui-invite-user-success': 'su solicitud de invitación enviada usuario',
  'cui-email-recipt': 'Ingrese correo electrónico del destinatario (múltiples separados por comas)',
  'cui-invite-verbiage': 'Invite a uno de los siguientes',
  'select': 'Seleccionar',
  'change-org': 'cambio Org',
  'cui-invite-user-sub': 'Registrarse como usuario para unirse',
  'cui-invite-user-select': 'Buscar una org',
  'cui-send-invitation': 'Enviar invitacion',
  'invite': 'Invitación',
  'cui-invite-tlo-success': 'Su solicitud de invitación enviada organización de nivel superior',
  'cui-invite-tlo': 'Invitar a una nueva organización',
  'cui-invite-division-success': 'Su solicitud de invitación enviada empresa',
  'cui-invite-division': 'Invitar a una organización',
  'cui-tlo-sub': 'Se registra como una nueva organización',
  'cui-division-sub': 'Registrarse como adminstrator dentro',
  'search-by-org-name': 'Búsqueda por nombre de la organización',
  'app-approval-error': 'Hubo un error en la aprobación de las solicitudes de la aplicación.',
  'modify-claims': 'modificar Reclamaciones',
  'unsuspend-app': 'Reactivar App',
  'remove-app': 'Eliminar aplicaciones',
  'user-details': 'Detalles de usuario',
  'reason': 'Razón',
  'required': 'Necesario',
  'cui-unsuspend-confirm': '¿Seguro desea reactivar ahora?',
  'unsuspend': 'Reactivar',
  'remove-confirm': '¿Estás seguro de que quieres eliminar ahora?',
  'remove': 'retirar',
  'my-organization': 'mi organización',
  'request-app': 'solicitud de Aplicación',
  'no-apps-found': 'No se encontraron aplicaciones.',
  'refine-search': 'Por favor, revise sus criterios de búsqueda.',
  'your-assign-role-success': 'Nuevo rol asignado',
  'cui-assigned-roles': 'Los roles asignados',
  'cui-available-roles': 'Roles disponibles',
  'cui-browse-by-category': 'Buscar por categoría',
  'cui-back-navigation-requests': 'navegación hacia atrás y Solicitudes',
  'cui-search-results': 'Resultados de la búsqueda',
  'cui-new-grant-search-results': 'Nueva Grant Resultados de la búsqueda',
  'cui-username-close': 'Nombre de usuario y la navegación cerca',
  'cui-user-no-apps': 'El usuario no tiene aplicaciones',
  'cui-no-roles-assigned': 'Este usuario no tiene los roles asignados.',
  'status-history': 'Historia de estado',
  'cui-no-status-history': 'Este usuario no tiene historial de estado.',
  'cui-pwd-reset-msg1': 'Restablecimiento de la contraseña es correcta. La nueva contraseña es:',
  'cui-pwd-reset-msg2': 'Nota: si usted está viendo sólo la primera mitad de la contraseña y luego la segunda mitad contraseña será enviada a los usuarios de correo electrónico registrado.',
  'users-upper': 'USUARIOS',
  'hierarchy-upper': 'JERARQUÍA',
  'privileges': 'privilegios',
  'expand-all': 'Expandir todo',
  'collapse-all': 'Desplegar todo',
  'no-records': 'No se encontrarón archivos.',
  'contact-us': 'Contáctenos',
  'cui-error-organization-request': 'No se puede recuperar datos de la solicitud de registro de esta organización.',
  'cui-error-organization-app-request': 'No se puede recuperar datos de solicitud de aplicación de esta organización',
  'cui-error-user-app-request': 'No se puede recuperar datos de solicitud de aplicación de este usuario',
  'assign': 'Asignar',
  'search-by-person-name': 'Búsqueda por nombre de la persona',
  'grant-history': 'Historia subvención',
  'request-history': 'Historial de solicitudes',
  'social-login': 'Iniciar sesión Social',
  'facebook': 'Facebook',
  'twitter': 'Gorjeo',
  'link': 'Enlazar',
  'unlink': 'Desconectar',
  'invalid-url': 'Esto no es una URL válida.',
  'linkedin': 'LinkedIn',
  'google': 'google',
  'administration': 'Administración',
  'services': 'Servicios',
  'n-phase': 'N - Aprobación Fase',
  'edit-package': 'Editar paquete',
  'is-requestable': 'es solicitable',
  'is-displayable': 'es visualizable',
  'is-grantable': 'es grantable',
  'require': 'Exigir',
  'is-requestable-desc': 'Indica si el usuario puede solicitar esta aplicación.',
  'is-grantable-desc': 'Indicar si esta solicitud se puede conceder directamente por la administración de la empresa para el usuario',
  'is-displayable-desc': 'Indicar si el icono del paquete se debe mostrar en la página Mi Aplicaciones',
  'require-reason-desc': 'Indique si este paquete, el usuario deberá suministrar una razón para solicitar este paquete',
  'company-admin': 'compañía de administración',
  'application-admin': 'aplicación de administración',
  'company-admin-desc': 'Esta es la fase de aprobación por defecto, debe ser sí, si no hay otra fase requerido',
  'application-admin-desc': '¿La aplicación de usuario solicitud tiene que ser aprobado por el administrador de la aplicación?',
  'add-admins': 'Añadir Administradores',
  'cardinality-indicator': 'Indicador de cardinalidad',
  'cui-one': 'Uno',
  'cui-many': 'Muchos',
  'claim-values': 'Los valores de reclamación',
  'cui-add': 'Añadir',
  'cui-view': 'Ver',
  'cui-claim': 'Reclamación',
  'cui-category': 'Categoría',
  'cui-service': 'Servicio',
  'cui-delete': 'Borrar',
  'federation-conn': 'Conexión Federación',
  'updated-date': 'Fecha actualizada',
  'target-url': 'URL de destino',
  'remote-app-id': 'Id de aplicaciones remotas',
  'mobile-sso-url': 'URL SSO móvil',
  'mobile-app-id': 'Mobile App ID',
  'cui-package': 'Paquete',
  'cui-create': 'Crear',
  'more-languages': 'Más idiomas',
  'duplicate-language-error': 'idiomas duplicados no están permitidos',
  'cui-nextstep': 'Siguiente',
  'create-package': 'crear paquete',
  'manage-package-claims': 'Manejo de Reclamaciones del paquete',
  'cardinality-indicator-error': 'Indicador de cardinalidad no puede ser uno',
  'value-id-exists': 'ID del valor ya existe',
  'claim-id-exists': 'Id reivindicación ya existe',
  'cui-new': 'Nuevo',
  'package-success-content': 'Paquete creado correctamente',
  'add-claims': 'Añadir Reclamaciones',
  'package-update-success': 'El paquete actualizado correctamente'
}

export {
  es
}



// WEBPACK FOOTER //
// ./src/plugins/i18n/es.js